<template>
  <div
    class="cf-card cf-card--clickable cf-flex cf-clear-padding"
    @click="viewOfferDetailsClickHandler"
  >
    <div class="cf-grid cf-grid--2-grid-column-left-large cf-full-width cf-padding-12">
      <div class="cf-flex cf-flex--column cf-flex--align-start cf-flex--justify-center cf-flex--gap-12 cf-max-width-400">
        <h4 class="cf-title cf-title--4 cf-no-wrap-ellipsis-multi-line">
          {{ offer.title }}
        </h4>

        <p
          v-if="offer.endDate"
          class="cf-subtitle cf-subtitle--3"
        >
          Expires {{ $formatDate(offer.endDate) }}
        </p>
      </div>

      <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-end">
        <button
          type="button"
          class="cf-button cf-button--sm cf-button--primary"
          :disabled="isDisabled"
          @click.stop="buttonClickHandler"
        >
          {{ buttonContent }}
        </button>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'CfOfferCardDetails',

    props: {
      offer: {
        type: Object,
        required: true
      },

      buttonContent: {
        type: String,
        required: true
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['currentUser']),

      isDisabled() {
        return !this.currentUser.allowInStoreOfferRedemption;
      }
    },

    methods: {
      buttonClickHandler() {
        this.$emit('set-offer', this.offer);
      },

      viewOfferDetailsClickHandler() {
        this.$openModal('offerDetails', { offer: this.offer });
      }
    }
  };
</script>
